import React, { useEffect } from "react";
import Footer from "../components/footer/Footer";
import SimilerBanner from "../components/similerBanner/SimilerBanner";
import DevelopmentProcess from "../components/developmentProcess/DevelopmentProcess";
import FutureSolution from "../components/futuresolution/FutureSolution";
import PioneeringChange from "../components/pioneeringChange/PioneeringChange";
import Testimonial from "../components/testimonila/Testimonial";
import CoverTheStack from "../components/coverthestack/CoverTheStack";
import { Helmet } from "react-helmet";
import MegaHeader from "../components/MegaHeader/MegaHeader";
import AIServices from "../components/ai-development-services/AIServices";
import WhyChooseBitsclan from "../components/why-choose-bitsclan/WhyChooseBitsclan";
import TrendsInsights from "../components/trends-n-insights/TrendsInsights";
import FAQ from "../components/Fqas/FAQ";
import DevOpsRoadMap from "../components/devops-roadmap/DevopsRoadmap";
import ContactSection from "../components/contactSection/ContactSection";
import DevOpsChallange from "../components/devops-challange/DevOpsChallange";
import { devOpsPageServices, mainBannerImg } from "../data/dev-ops-data";
import { useTranslation } from "react-i18next";
import IndustriesSection from "../components/newIndustriesSection";
import SoftwareCompanyCta from "../components/software-company-cta/SoftwareCompanyCta";
import MegaMenu from "../components/MegaMenu/MegaMenu";
import NewCaseStudySection from "../components/new-case-study-section/NewCaseStudySection";
import OurServices from "../components/our-services/OurServices";
import ServicesPageBanner from "../components/services-page-banner/ServicesPageBanner";
import TrustedPartner from "../components/trustedPartners/TrustedPartner";
import NewTestimonials from "../components/new-testimonials/NewTestimonials";
import { AiMlPageData } from "../data/ai-ml-data";
import WhyChooseUs from "../components/why-choose-us/WhyChooseUs";
import { engagementModelContent } from "../data/engagementModelContent";
import SimpleModels from "../components/simpleEngagementModels";

const DevOpsServices = () => {
  const { t } = useTranslation("industries");
  const translatedTabData = t("tabData", { returnObjects: true });

  const { t: tDevOps } = useTranslation("devOpsPage");
  const bannerContent = tDevOps("devOpsPageBanner", { returnObjects: true });
  const servicesContent = tDevOps("devOpsPageServices", {
    returnObjects: true,
  });
  const processStepsData = tDevOps("devOpsPageProcessSteps", {
    returnObjects: true,
  });
  const hireUsSectionData = tDevOps("devOpsHireUsSection", {
    returnObjects: true,
  });
  const solutionCardSection = tDevOps("devOpsSolutionCardSection", {
    returnObjects: true,
  });
  const coverTheStackSection = tDevOps("devOpsPageCoverTheStack", {
    returnObjects: true,
  });
  const whyChoseUsSectionData = tDevOps("devOpsPageWhyChoseUs", {
    returnObjects: true,
  });
  const faqSectionData = tDevOps("devOpsPageFaqS", { returnObjects: true });
  const pioneerChangeHeadings = tDevOps("devOpsPagePioneerHeading", {
    returnObjects: true,
  });

  const { t: tmetaTitles } = useTranslation("metaTitles");
  const metaTitle = tmetaTitles("devOpsMetaTitle", { returnObjects: false });

  const { t: tfooter } = useTranslation("footer");
  const footerCtaContent = tfooter("footerCtaContent", {
    returnObjects: true,
  });
  return (
    <>
      <Helmet>
        <title>DevOps Managed Services & Solutions Provider Company | Bitsclan</title>
        <meta
          name="description"
          content="Your trusted DevOps development company. Revolutionize your software process with our effective DevOps managed services. Partner with Bitsclan for frequent updates and a near-zero change failure rate."
        />
      </Helmet>

      <MegaMenu />

      <ServicesPageBanner
        shortHeading="Devops Services"
        mainHeading="Trusted by <span>Startups,</span> SMBs, & Enterprises Around the Globe"
        description="Let us take your eureka moment from a raw concept to feasibility assessment, & from design to development. Our custom software development services offer robust, secure, scalable solutions to ensure sustainable growth for your business."
      />
      <TrustedPartner />

      <OurServices
        buttonText="Start Your Journey"
        servicesCardsData={devOpsPageServices?.cardsData}
        shortHeading={devOpsPageServices?.shortHeading}
        mainHeading={devOpsPageServices?.mainHeading}
        description={devOpsPageServices?.description}
      />

      <NewTestimonials
        shortHeading="Our Testimonials"
        mainHeading="Voices of <span>Global</span> Enterprises on Our DevOps Excellence"
        description="Discover why businesses trust Bitsclan for streamlined DevOps solutions. Read real feedback from clients who achieved faster delivery, improved reliability, & seamless collaboration with our services."
      />

      <WhyChooseUs
        heading="Advantage of Partnering With Us"
        greenHeading="The Strategic "
        shortHeading="Why Choose Us"
        content="Organizations rely on us for delivering end-to-end DevOps services, including CI/CD automation, cloud-native infrastructure, & continuous monitoring. By aligning innovation with proven DevOps practices, we help businesses accelerate release cycles, enhance system reliability, & achieve sustainable growth."
        stats={[
          // {
          //   number: "2017",
          //   title: "Delivering Excellence Since"
          // },
          {
            number: "120+",
            title: "Successful DevOps Projects Delivered"
          },
          {
            number: "100+",
            title: "Certified DevOps Professionals"
          },
        ]}
      />

      <NewCaseStudySection shortHeading="Our case studies" heading="Trusted by the World's Leading Companies" description="Partner with Bitsclan’s skilled development teams for AI, web, mobile, & enterprise solutions. Our proven offshore software development approach delivers exceptional results, blending innovation & scalability to drive lasting business success across industries." />

      <CoverTheStack
        whereStart={coverTheStackSection?.converTheStackContent?.defaultOpenTab}
        mainHeading={coverTheStackSection?.converTheStackContent?.mainHeading}
        subHeading={
          coverTheStackSection?.converTheStackContent?.sectionDescription
        }
        tabs={coverTheStackSection?.tabs}
        tabItems={coverTheStackSection?.tabItems}
      />

      <SimpleModels content={engagementModelContent} />

      <PioneeringChange
        tabData={translatedTabData}
        greenHeading={pioneerChangeHeadings?.greenHeading}
        mainHeading={pioneerChangeHeadings?.mainHeading}
        content={pioneerChangeHeadings?.sectionDescription}
      />

      {/* <AIServices
        services={servicesContent?.servicesCards}
        mainHeading={servicesContent?.servicesContent?.mainHeading}
        content={servicesContent?.servicesContent?.sectionDescription}
      /> */}


      <FutureSolution
        heading={solutionCardSection?.solutionDataContent?.mainHeading}
        subHeading={
          solutionCardSection?.solutionDataContent?.sectionDescription
        }
        solutions={solutionCardSection?.solutionsDataCards}
      />

      <DevelopmentProcess
        heading={processStepsData?.processStepsContent?.mainHeading}
        greenHeading={processStepsData?.processStepsContent?.greenHeading}
        description={processStepsData?.processStepsContent?.sectionDescription}
        processSteps={processStepsData?.processSteps}
      />

      <div className="left-align-content-box">
        <WhyChooseBitsclan
          tabs={whyChoseUsSectionData?.whyChoseBitsclanTabs}
          heading={whyChoseUsSectionData?.whyChoseBitsclanContent?.mainHeading}
          subheading={
            whyChoseUsSectionData?.whyChoseBitsclanContent?.sectionDescription
          }
          bgClassHere="bg-light-grey"
          btnText2={
            whyChoseUsSectionData?.whyChoseBitsclanContent?.sectionButtonText
          }
        />
      </div>



      <DevOpsChallange
        HireUsData={hireUsSectionData?.hireUsDataCard}
        heading={hireUsSectionData?.hireUsDataContent?.mainHeading}
        content={hireUsSectionData?.hireUsDataContent?.sectionDescription}
        HireUsButtonText={hireUsSectionData?.hireUsDataContent?.buttonText}
      />


      <DevOpsRoadMap />

      <TrendsInsights category="devops-services" />

      <FAQ
        faqs={faqSectionData?.questionAndAnswer}
        mainHeading={faqSectionData?.faqDataContent?.mainHeading}
      />

      {/* <ContactSection /> */}

      <SoftwareCompanyCta content={footerCtaContent} />

      <Footer />
    </>
  );
};

export default DevOpsServices;
